var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSensitivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10904_32468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.326 15.219C41.3805 13.9598 41.1364 12.704 40.6085 11.527C40.0806 10.35 39.2796 9.27621 38.2535 8.369C37.2274 7.46179 35.9971 6.74021 34.6363 6.24733C33.2755 5.75445 31.8121 5.5 30.3335 5.5C28.8549 5.5 27.3914 5.75445 26.0306 6.24733C24.6698 6.74021 23.4396 7.46179 22.4135 8.369C21.3873 9.27621 20.5864 10.35 20.0585 11.527C19.5305 12.704 19.2865 13.9598 19.3409 15.219V20.668L23.0076 23.8049H19.3409V40.1264L30.341 49.5L41.326 40.1264V30.2195H37.6593L41.326 27.082V15.219Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3335 55.5V15.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3335 27.5L30.3335 31.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3335 35.5L30.3335 38.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3335 18.5L30.3335 21.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10904_32468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.333496 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensitivity);
export default __webpack_public_path__ + "static/media/sensitivity.2d54acb51552b6af6ca5e8bd769aea02.svg";
export { ForwardRef as ReactComponent };